import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { AnimatedLink } from '../../../components/animated-link/AnimatedLink';
import { NotificationList } from './list/NotificationList';
import styles from './notification_content.module.scss';
import { NavDropdownContent } from '../../components/dropdown-content/NavDropdownContent';
import { NavDropdownFooter } from '../../components/dropdown-footer/NavDropdownFooter';

type Props = {
  readNotificationContent: Function;
};

export const NotificationContent: FC<Props> = ({ readNotificationContent }) => {
  return (
    <NavDropdownContent className={styles.container}>
      <NotificationList readNotificationContent={readNotificationContent} />
      <NavDropdownFooter>
        <AnimatedLink component={Link} to="/alertes?source=notif_dropdown">
          <FormattedMessage id="navigation/notification/components/NotificationContent.tsx/1" />
        </AnimatedLink>
      </NavDropdownFooter>
    </NavDropdownContent>
  );
};
